import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as s } from "react";
import { I as i } from "../../../../IconBase-CxZyIWw2.js";
const a = s((r, t) => /* @__PURE__ */ o.jsx(
  i,
  {
    ref: t,
    ...r,
    image: (e) => /* @__PURE__ */ o.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...e,
        children: /* @__PURE__ */ o.jsx(
          "path",
          {
            fill: "currentColor",
            d: "m4.414 7 3.293-3.293-1.414-1.414-5 5a1 1 0 0 0 0 1.414l5 5 1.414-1.414L4.414 9H15V7z"
          }
        )
      }
    )
  }
));
a.displayName = "ArrowLeftIcon";
export {
  a as ArrowLeftIcon,
  a as default
};
//# sourceMappingURL=index.js.map
